import { render, staticRenderFns } from "./Consumos.vue?vue&type=template&id=26e588d2"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports